import React, { useRef, useState, useEffect } from "react";

// Mouse-following magnetic hover effect.
// Activates when cursor is within `padding` of the element edge.
export function Magnet({
    children,
    padding = 80,
    strength = 6,
    activeTransition = "transform 0.3s ease-out",
    inactiveTransition = "transform 0.6s ease-in-out",
    className = "",
    style = {},
}) {
    const ref = useRef(null);
    const [active, setActive] = useState(false);

    useEffect(() => {
        const node = ref.current;
        if (!node) return;

        function handleMove(e) {
            const rect = node.getBoundingClientRect();
            const cx = rect.left + rect.width / 2;
            const cy = rect.top + rect.height / 2;
            const dx = e.clientX - cx;
            const dy = e.clientY - cy;

            const halfW = rect.width / 2 + padding;
            const halfH = rect.height / 2 + padding;
            const inX = Math.abs(dx) < halfW;
            const inY = Math.abs(dy) < halfH;

            if (inX && inY) {
                setActive(true);
                node.style.transition = activeTransition;
                node.style.transform = `translate3d(${dx / strength}px, ${dy / strength}px, 0)`;
            } else if (active) {
                setActive(false);
                node.style.transition = inactiveTransition;
                node.style.transform = "translate3d(0, 0, 0)";
            }
        }

        window.addEventListener("mousemove", handleMove);
        return () => window.removeEventListener("mousemove", handleMove);
    }, [padding, strength, activeTransition, inactiveTransition, active]);

    return (
        <div
            ref={ref}
            className={className}
            style={{ willChange: "transform", ...style }}
        >
            {children}
        </div>
    );
}
